import { render, staticRenderFns } from "./UsagePanel.vue?vue&type=template&id=e2bdf694&scoped=true&"
import script from "./UsagePanel.vue?vue&type=script&lang=js&"
export * from "./UsagePanel.vue?vue&type=script&lang=js&"
import style0 from "./UsagePanel.vue?vue&type=style&index=0&id=e2bdf694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bdf694",
  null
  
)

export default component.exports